import React from 'react';
import { styled } from '@glitz/react';
import { H3, Paragraph, ResponsiveSize, ArticleTag, TextLabel } from 'Shared/SharedComponents/atoms/Typography';
import SustainabilityViewModel from 'Product/SustainabilityViewModel.type';
import Html from 'Shared/Partials/PropertyTypes/Html';
import { AspectImageVideoBackground } from 'Shared/SharedComponents/molecules/ImageVideoBackground';
import { createGridClasses } from 'Shared/grid';
import * as style from 'Shared/Style';
import SwiperList from 'Shared/SwiperList';
import Link from 'Shared/Link';
import { PictureImage, Preset } from 'Shared/Image';

type PropType = {
  sustainability: SustainabilityViewModel;
  isCompact: boolean;
};

const Intro = styled(Paragraph, {
  marginBottom: '16px'
})

const HtmlBody = styled.div({
});

const SwiperWrap = styled.div({
  marginTop: '40px',
  ['@media ' + style.mediaMinLarge]: {
    marginTop: '80px',
  },
})

const Heading = styled(H3, {
  marginTop: '12px'
})

const MainTag = styled(ArticleTag, {
  marginTop: '16px'
})

const Tag = styled(ArticleTag, {
  marginTop: '12px'
})

const ItemImage = styled(PictureImage, {
  position: 'absolute',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center center',
  borderRadius: '8px'
})

export const ItemLink = styled(Link, {
  color: 'inherit',
  textDecoration: 'none',
});


function SustainabilityContent({ sustainability, isCompact }: PropType) {
  return (
    <div>
      <div className="grid subgrid-11">
        <div className={createGridClasses(12, 5)}>
          <Intro fontSize={ResponsiveSize.D32_M24}>
            {sustainability?.mainIntro}
          </Intro>
          {sustainability?.mainBody && <Html
            className='editorial-text no-margin'
            component={HtmlBody}
            html={sustainability?.mainBody.html}
          />}
        </div>
      </div>
      <SwiperWrap>
        <SwiperList
          slidesPerView={isCompact ? 1.75 : 3.75}
          spaceBetween={isCompact ? 8 : 16}
          isCompact={isCompact}
          showNav={false}
          cssMode={true}
        >
          {sustainability?.contentItems?.map((contentItem, index) => (
            <div className='swiper-slide' key={`stb_item-${index}`}>
              <ItemLink to={contentItem.url}>
                <AspectImageVideoBackground
                  paddingTop={'100%'}
                  borderRadius={8}
                  breakPoint={isCompact ? 0 : 4}
                >
                  {contentItem.image?.url && (
                    <ItemImage src={contentItem.image?.url} preset={Preset.CmsListItem} />
                  )}
                </AspectImageVideoBackground>
                {contentItem.tag && <MainTag>{contentItem.tag}</MainTag>}
                <Heading>{contentItem.heading}</Heading>

                {contentItem.tags?.length > 0 && (
                  <Tag>
                    {contentItem.tags?.reduce((tagString, tag) => {
                      return `${tagString}, ${tag}`;
                    })}
                  </Tag>
                )}
              </ItemLink>
            </div>
          ))}
        </SwiperList>
      </SwiperWrap>
    </div>
  );
}

export default SustainabilityContent;
